import React from 'react';
import classNames from 'classnames';

import styles          from './Icons.css';
import SpainBadge      from '../../../public/svg/spain-badge.svg';

export const SpainIcon = React.memo((props: any) => (
    <div className={styles.spainIconContainer}>
        <SpainBadge className = {classNames(styles.spainIcon)} aria-hidden = "true"/>
        <span className={styles.esSign}>es</span>
    </div>
));
